import {SupportedLanguage} from '~/i18n'
import {useUser} from '~/shell/user'

import EmptyStatesAnalyticsIllustrationDa from './images/empty-state-analytics-da.svg'
import EmptyStatesAnalyticsIllustrationDe from './images/empty-state-analytics-de.svg'
import EmptyStatesAnalyticsIllustrationEn from './images/empty-state-analytics-en.svg'
import EmptyStatesAnalyticsIllustrationEs from './images/empty-state-analytics-es.svg'
import EmptyStatesAnalyticsIllustrationFi from './images/empty-state-analytics-fi.svg'
import EmptyStatesAnalyticsIllustrationFr from './images/empty-state-analytics-fr.svg'
import EmptyStatesAnalyticsIllustrationIt from './images/empty-state-analytics-it.svg'
import EmptyStatesAnalyticsIllustrationNl from './images/empty-state-analytics-nl.svg'
import EmptyStatesAnalyticsIllustrationNo from './images/empty-state-analytics-no.svg'
import EmptyStatesAnalyticsIllustrationPt from './images/empty-state-analytics-pt.svg'
import EmptyStatesAnalyticsIllustrationSv from './images/empty-state-analytics-sv.svg'
import EmptyStatesBudgetsIllustrationDa from './images/empty-state-budgets-da.svg'
import EmptyStatesBudgetsIllustrationDe from './images/empty-state-budgets-de.svg'
import EmptyStatesBudgetsIllustrationEn from './images/empty-state-budgets-en.svg'
import EmptyStatesBudgetsIllustrationEs from './images/empty-state-budgets-es.svg'
import EmptyStatesBudgetsIllustrationFi from './images/empty-state-budgets-fi.svg'
import EmptyStatesBudgetsIllustrationFr from './images/empty-state-budgets-fr.svg'
import EmptyStatesBudgetsIllustrationIt from './images/empty-state-budgets-it.svg'
import EmptyStatesBudgetsIllustrationNl from './images/empty-state-budgets-nl.svg'
import EmptyStatesBudgetsIllustrationNo from './images/empty-state-budgets-no.svg'
import EmptyStatesBudgetsIllustrationPt from './images/empty-state-budgets-pt.svg'
import EmptyStatesBudgetsIllustrationSv from './images/empty-state-budgets-sv.svg'
import EmptyStateLimitsIllustrationDa from './images/empty-state-limits-da.svg'
import EmptyStateLimitsIllustrationDe from './images/empty-state-limits-de.svg'
import EmptyStateLimitsIllustrationEn from './images/empty-state-limits-en.svg'
import EmptyStateLimitsIllustrationEs from './images/empty-state-limits-es.svg'
import EmptyStateLimitsIllustrationFi from './images/empty-state-limits-fi.svg'
import EmptyStateLimitsIllustrationFr from './images/empty-state-limits-fr.svg'
import EmptyStateLimitsIllustrationIt from './images/empty-state-limits-it.svg'
import EmptyStateLimitsIllustrationNl from './images/empty-state-limits-nl.svg'
import EmptyStateLimitsIllustrationNo from './images/empty-state-limits-no.svg'
import EmptyStateLimitsIllustrationPt from './images/empty-state-limits-pt.svg'
import EmptyStateLimitsIllustrationSv from './images/empty-state-limits-sv.svg'
import EmptyStatesSubscriptionsIllustrationDa from './images/empty-state-subscriptions-da.svg'
import EmptyStatesSubscriptionsIllustrationDe from './images/empty-state-subscriptions-de.svg'
import EmptyStatesSubscriptionsIllustrationEn from './images/empty-state-subscriptions-en.svg'
import EmptyStatesSubscriptionsIllustrationEs from './images/empty-state-subscriptions-es.svg'
import EmptyStatesSubscriptionsIllustrationFi from './images/empty-state-subscriptions-fi.svg'
import EmptyStatesSubscriptionsIllustrationFr from './images/empty-state-subscriptions-fr.svg'
import EmptyStatesSubscriptionsIllustrationIt from './images/empty-state-subscriptions-it.svg'
import EmptyStatesSubscriptionsIllustrationNl from './images/empty-state-subscriptions-nl.svg'
import EmptyStatesSubscriptionsIllustrationNo from './images/empty-state-subscriptions-no.svg'
import EmptyStatesSubscriptionsIllustrationPt from './images/empty-state-subscriptions-pt.svg'
import EmptyStatesSubscriptionsIllustrationSv from './images/empty-state-subscriptions-sv.svg'
import EmptyStateTeamsIllustrationDa from './images/empty-state-teams-da.svg'
import EmptyStateTeamsIllustrationDe from './images/empty-state-teams-de.svg'
import EmptyStateTeamsIllustrationEn from './images/empty-state-teams-en.svg'
import EmptyStateTeamsIllustrationEs from './images/empty-state-teams-es.svg'
import EmptyStateTeamsIllustrationFi from './images/empty-state-teams-fi.svg'
import EmptyStateTeamsIllustrationFr from './images/empty-state-teams-fr.svg'
import EmptyStateTeamsIllustrationIt from './images/empty-state-teams-it.svg'
import EmptyStateTeamsIllustrationNl from './images/empty-state-teams-nl.svg'
import EmptyStateTeamsIllustrationNo from './images/empty-state-teams-no.svg'
import EmptyStateTeamsIllustrationPt from './images/empty-state-teams-pt.svg'
import EmptyStateTeamsIllustrationSv from './images/empty-state-teams-sv.svg'

export type PageOrigin =
    | 'pocket'
    | 'subscriptions'
    | 'analytics'
    | 'budgets'
    | 'teams'
    | 'limits'
    | 'billing'
    | 'settings'
    | 'company-review'

export type PageSection =
    | 'pocket-guide'
    | 'upgrade-banner'
    | 'mileage-upgrade-banner'
    | 'review-overview'

export const useLocalisedIllustration = ({type}: {type: PageOrigin}) => {
    const user = useUser()
    // Get only the generic language code without locales
    const userLanguage = (user?.language?.slice(0, 2) as SupportedLanguage) || SupportedLanguage.EN

    // Make sure there is always a type set, this should not happen
    const IllustrationType = IllustrationsConfig[type] ?? IllustrationsConfig.subscriptions

    // Default to English if language not found
    const illustration = IllustrationType[userLanguage] ?? IllustrationType.en

    return {illustration, userLanguage}
}

const IllustrationsConfig: Record<string, Record<string, string>> = {
    budgets: {
        [SupportedLanguage.EN]: EmptyStatesBudgetsIllustrationEn,
        [SupportedLanguage.DE]: EmptyStatesBudgetsIllustrationDe,
        [SupportedLanguage.FR]: EmptyStatesBudgetsIllustrationFr,
        [SupportedLanguage.NL]: EmptyStatesBudgetsIllustrationNl,
        [SupportedLanguage.ES]: EmptyStatesBudgetsIllustrationEs,
        [SupportedLanguage.DA]: EmptyStatesBudgetsIllustrationDa,
        [SupportedLanguage.SV]: EmptyStatesBudgetsIllustrationSv,
        [SupportedLanguage.FI]: EmptyStatesBudgetsIllustrationFi,
        [SupportedLanguage.IT]: EmptyStatesBudgetsIllustrationIt,
        [SupportedLanguage.PT]: EmptyStatesBudgetsIllustrationPt,
        [SupportedLanguage.NO]: EmptyStatesBudgetsIllustrationNo,
    },
    analytics: {
        [SupportedLanguage.EN]: EmptyStatesAnalyticsIllustrationEn,
        [SupportedLanguage.DE]: EmptyStatesAnalyticsIllustrationDe,
        [SupportedLanguage.FR]: EmptyStatesAnalyticsIllustrationFr,
        [SupportedLanguage.NL]: EmptyStatesAnalyticsIllustrationNl,
        [SupportedLanguage.ES]: EmptyStatesAnalyticsIllustrationEs,
        [SupportedLanguage.DA]: EmptyStatesAnalyticsIllustrationDa,
        [SupportedLanguage.SV]: EmptyStatesAnalyticsIllustrationSv,
        [SupportedLanguage.FI]: EmptyStatesAnalyticsIllustrationFi,
        [SupportedLanguage.IT]: EmptyStatesAnalyticsIllustrationIt,
        [SupportedLanguage.PT]: EmptyStatesAnalyticsIllustrationPt,
        [SupportedLanguage.NO]: EmptyStatesAnalyticsIllustrationNo,
    },
    limits: {
        [SupportedLanguage.EN]: EmptyStateLimitsIllustrationEn,
        [SupportedLanguage.DE]: EmptyStateLimitsIllustrationDe,
        [SupportedLanguage.FR]: EmptyStateLimitsIllustrationFr,
        [SupportedLanguage.NL]: EmptyStateLimitsIllustrationNl,
        [SupportedLanguage.ES]: EmptyStateLimitsIllustrationEs,
        [SupportedLanguage.DA]: EmptyStateLimitsIllustrationDa,
        [SupportedLanguage.SV]: EmptyStateLimitsIllustrationSv,
        [SupportedLanguage.FI]: EmptyStateLimitsIllustrationFi,
        [SupportedLanguage.IT]: EmptyStateLimitsIllustrationIt,
        [SupportedLanguage.PT]: EmptyStateLimitsIllustrationPt,
        [SupportedLanguage.NO]: EmptyStateLimitsIllustrationNo,
    },
    subscriptions: {
        [SupportedLanguage.EN]: EmptyStatesSubscriptionsIllustrationEn,
        [SupportedLanguage.DE]: EmptyStatesSubscriptionsIllustrationDe,
        [SupportedLanguage.FR]: EmptyStatesSubscriptionsIllustrationFr,
        [SupportedLanguage.NL]: EmptyStatesSubscriptionsIllustrationNl,
        [SupportedLanguage.ES]: EmptyStatesSubscriptionsIllustrationEs,
        [SupportedLanguage.DA]: EmptyStatesSubscriptionsIllustrationDa,
        [SupportedLanguage.SV]: EmptyStatesSubscriptionsIllustrationSv,
        [SupportedLanguage.FI]: EmptyStatesSubscriptionsIllustrationFi,
        [SupportedLanguage.IT]: EmptyStatesSubscriptionsIllustrationIt,
        [SupportedLanguage.PT]: EmptyStatesSubscriptionsIllustrationPt,
        [SupportedLanguage.NO]: EmptyStatesSubscriptionsIllustrationNo,
    },
    teams: {
        [SupportedLanguage.EN]: EmptyStateTeamsIllustrationEn,
        [SupportedLanguage.DE]: EmptyStateTeamsIllustrationDe,
        [SupportedLanguage.FR]: EmptyStateTeamsIllustrationFr,
        [SupportedLanguage.NL]: EmptyStateTeamsIllustrationNl,
        [SupportedLanguage.ES]: EmptyStateTeamsIllustrationEs,
        [SupportedLanguage.DA]: EmptyStateTeamsIllustrationDa,
        [SupportedLanguage.SV]: EmptyStateTeamsIllustrationSv,
        [SupportedLanguage.FI]: EmptyStateTeamsIllustrationFi,
        [SupportedLanguage.IT]: EmptyStateTeamsIllustrationIt,
        [SupportedLanguage.PT]: EmptyStateTeamsIllustrationPt,
        [SupportedLanguage.NO]: EmptyStateTeamsIllustrationNo,
    },
}
